// extracted by mini-css-extract-plugin
export default {"brandTrendingWrap":"xG-z"};